import React from 'react';
import moment from 'moment';
import { Modal, Tag, Tooltip } from 'antd';
import { MoreMenu, MoreTags } from 'datastake-daf/dist/components';

export const linkingColumns = (t, module = 'pme') => [];

const statusValues = [
  { label: 'Active', value: 'active' },
  { label: 'Pending', value: 'pending' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Deleted', value: 'deleted' },
]

export default function getColumns(
  t = s => s,
  module = 'pme',
  filterBy = 'show',
  sourceId,
  expandedRows = [],
  activeFilters = {},
  push = () => { },
  deleteProgram = () => { },
  acceptProgram = () => { },
  declineProgram = () => { },
) {
  const cols = [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'datastakeId',
      overview: true,
      ellipsis: true,
      show: true,
      project: true,
      publication: true,
      defaultSortOrder: activeFilters.sortBy === 'datastakeId' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      render: (id, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return id;
      },
      search: true,
      width: 160,
      pubblication: true,
    },
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
      defaultSortOrder: activeFilters.sortBy === 'name' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      overview: true,
      show: true,
      project: true,
      publication: true,
      primarySearch: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Country'),
      dataIndex: 'country',
      key: 'country',
      show: true,
      // render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      render: (country, all) => {
        if (all.empty) {
          return '';
        }

        if (!country.length) {
          return '--';
        }

        return <MoreTags values={country} />;
      },
      ellipsis: true,
      project: true,
      search: true,
      publication: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'country' ? activeFilters.sortDir : undefined,
    },
    {
      title: t('AMPs'),
      dataIndex: 'amps',
      key: 'amps',
      show: true,
      render: (val, all) => {
        if (all.empty) {
          return '';
        }

        const _val = (val || []).filter((v) => v.id && v.name);

        return _val.length ? <MoreTags values={_val.map((m) => ({ value: m.id, label: m.name }))} /> : '--';
      },
      ellipsis: true,
      project: true,
      search: true,
      publication: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'country' ? activeFilters.sortDir : undefined,
    },
    {
      title: t('Commodity'),
      dataIndex: 'products',
      key: 'products',
      show: true,
      // render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      render: (val, all) => all.empty ? '' : (
        <MoreTags values={val.map((m) => ({ value: m, label: m }))} />
      ),
      ellipsis: true,
      project: true,
      search: true,
      publication: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'country' ? activeFilters.sortDir : undefined,
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
      overview: true,
      show: true,
      search: true,
      render: (status, all) => {
        if (all.empty || !status?.value) {
          return <div className="daf-default-cell" />;
        }

        let color = '';

        switch (status?.value) {
          case 'active':
            color = 'green'
            break;
          case 'rejected':
          case 'deleted':
            color = 'red'
            break;
          default:
            color = 'orange'
            break;
        }

        const _label = statusValues.find((v) => v.value === status.value)?.label;

        return <Tag color={color}>{t(_label || status.label)}</Tag>
      },
    },
    {
      title: t('Last Update'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      show: true,
      project: true,
      search: false,
      publication: true,
      ellipsis: true,
      render: (updatedAt, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        const date = item.publishedAt || updatedAt;
        const title = date ? moment(date).format('DD MMM YYYY') : '';
        return <Tooltip title={title}>{title}</Tooltip>
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      width: 60,
      show: true,
      project: true,
      publication: false,
      render: (_, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }
        let items = [];
        switch (item.status?.value) {
          case 'active':
            items = [
              {
                label: t('Analysis'),
                onClick: () => push(`/app/${module}/analysis/programs/${item.id}`),
                key: "analysis",
              },
              {
                label: t('Details'),
                onClick: () => push(`/app/${module}/view/programs/${item.id}`),
                key: "view",
              },
            ];
            if (item.authorId === sourceId) {
              items.push(
                {
                  label: t('Delete Program'),
                  onClick: () => {
                    Modal.confirm({
                      title: t('Are you sure you want to delete this program?'),
                      content: t('Associated partners will no longer have access to its information content.'),
                      okText: t('Ok'),
                      cancelText: t('No'),
                      onOk: () => {
                        deleteProgram(item.dbId)
                      },
                    })
                  },
                  key: "delete",
                });
            }
            break;

          case 'pending':
            items = [
              {
                label: t('Approve Program'),
                onClick: () => {
                  Modal.confirm({
                    title: t('Are you sure you want to approve this program?'),
                    content: '',
                    okText: t('Ok'),
                    cancelText: t('No'),
                    onOk: () => {
                      acceptProgram(item.dbId);
                    },
                  })
                },
                key: "approve",
              },
              {
                label: t('Reject Program'),
                onClick: () => {
                  Modal.confirm({
                    title: t('Are you sure you want to reject this program?'),
                    content: '',
                    okText: t('Ok'),
                    cancelText: t('No'),
                    onOk: () => {
                      declineProgram(item.dbId);
                    },
                  })
                },
                key: "decline",
              },
            ]
            break;
          default:
            break;

        }

        if (items.length === 0) {
          return <div className="daf-default-cell" />;
        }
        return <MoreMenu items={items} />;
      }
    }
  ];

  return cols.filter(c => c[filterBy]);
}
